import Layout from '../components/Layout';
import AdminCustomer from '../components/adminCustomer';


const MiCuenta = () => {

	return (
		<Layout
			pagina={"Mi cuenta"}
		>
			<div className='w-full pt-20 pb-20'>
                <AdminCustomer />
			</div>
		</Layout>
	)
}

export default MiCuenta